<template lang="pug">
	div.contenedor(ref="contenedor", style="margin-top:-20px;")
		div.colA
			.formulario
				.card
					.card-body
						div.text-center
							img(v-if="imagenEmisora", :src="imagenEmisora", style="max-height:50px;max-width:90%;margin-bottom:5px;")
						.form-group
							label Emisora
							select.form-control(v-model="EmisoraID", tabindex="1")
								option(:value="null") Selecciona
								option(
									v-for="emi in listadoEmisoras"
									:key="emi.ID_emisora"
									:value="emi.xframe_ID"
								) {{emi.nombre}}
						.input-group.mt-2
							.input-group-prepend
								button.btn.btn-primary(@click="cambiaDia(-1)")
									span.fa.fa-caret-left
							datepicker(
								:language="$dateLang"
								:monday-first="true"
								v-model="dia"
								:bootstrap-styling="true"
								input-class="form-control"
								format="D dd MMM yyyy"
							)
							.input-group-append
								button.btn.btn-primary(@click="cambiaDia(1)")
									span.fa.fa-caret-right
						span(ref="imgDrag")
						br
						.btn-group
							button.btn(tabindex="2", title="Ocultar bloques vacíos", :class="(ocultarBloquesVacios) ? 'btn-primary' : ''", @click="toggleOmitir")
								span.fa(:class="(!ocultarBloquesVacios) ? 'fa-eye' : 'fa-eye-slash'")
							button.btn.btn-warning(@click="busquedaGlobal = true", title="Buscar ficheros en todo el sistema")
								span.fa.fa-search
							button.btn.btn-warning(@click="actualizarBloques = true", title="Actualizar bloques")
								span.fa.fa-refresh
						.input-group.mt-2
							input.form-control(placeholder="Buscar inserción", v-model="buscaInsercion")
							.input-group-append
								button.btn.btn-primary(@click="buscarInserciones")
									span.fa.fa-search
			.favoritos
				favoritos(
					style="flex-grow: 1;align-self:stretch;align-content: stretch;"
				)
		div.colB
			bloques.contieneTabla
			parrilla(
				:bloque="bloqueActivo"
				:filtro="filtro"
				:insertar="objetosInsertar"
				@reproducir="reproducir = $event"
				@actualizar="actualizarBloques = true"
			)
		div.colC
			div.contieneBuzones
				div.bg-dark.text-white.p-1
					span.fa.fa-folder.mr-2
					| Buzones
				arbol-buzones(:listado="listadoBuzones", v-if="listadoBuzones.length > 0", :nivel="0", :activo="buzonActivo", @select="seleccionaBuzon")
			div.contieneFicheros
				objetos-buzon(
					:buzon="buzonActivo"
					:bloque="bloqueActivo"
					@reproducir="reproducir = $event"
					@insertar="objetosInsertar = $event"
				)
		reproductor(:id-objeto="reproducir", @cerrar="reproducir = null")
		busqueda-global(v-if="busquedaGlobal", @cerrar="busquedaGlobal = null")
</template>

<script>
import ArbolBuzones from './arbol-buzones'
import ObjetosBuzon from './objetos-buzon.vue'
import Bloques from './bloques.vue'
import Parrilla from './parrilla.vue'
import Reproductor from '../../componentes/reproductor.vue'
import Favoritos from './favoritos.vue'
import BusquedaGlobal from './busqueda-global.vue'
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
export default {
	components: {
		'arbol-buzones': ArbolBuzones,
		'objetos-buzon': ObjetosBuzon,
		'bloques': Bloques,
		'parrilla': Parrilla,
		'reproductor': Reproductor,
		'favoritos': Favoritos,
		'busqueda-global': BusquedaGlobal
	},
	data () {
		return {
			filtro: null,
			actualizarBloques: false,
			busquedaGlobal: false,
			insercionActiva: null,
			inserciones: [],
			objetosInsertar: [],
			arrastrando: null,
			buzonActivo: null,
			listadoEmisoras: [],
			listadoBuzones: [],
			reproducir: null
		}
	},
	created () {
		this.filtro = this.filtroStore
		this.getListadoEmisoras()
		this.getFavoritos()
		if (!this.bloqueActivo) {
			this.getBuzones()
		}
	},
	mounted () {
		window.addEventListener('resize', this.calculaAlto)
		this.calculaAlto()
	},
	watch: {
		bloqueActivo: function (newVal) {
			if (newVal) {
				this.getParrilla(this.filtroPost)
			}
		}
	},
	computed: {
		...mapState({
			'bloqueActivo': state => state['organizar-emisoras'].bloqueActivo,
			'filtroStore': state => state['organizar-emisoras'].filtro
		}),
		...mapGetters({
			'ocultarBloquesVacios': 'organizar-emisoras/omitirBloquesSinMatricula'
		}),
		imagenEmisora () {
			if (this.EmisoraID && this.listadoEmisoras.length > 0) {
				const emisora = this.listadoEmisoras.filter(e => (e.xframe_ID === this.EmisoraID))[0]
				return emisora.logotipo || null
			}
			return null
		},
		EmisoraID: {
			get () {
				return this.filtroStore.EmisoraID
			},
			set (data) {
				this.setFiltro({EmisoraID: data})
			}
		},
		dia: {
			get () {
				return new Date(this.filtroStore.dia * 1000)
			},
			set (value) {
				this.setFiltro({dia: Math.round(value.getTime() / 1000)})
			}
		},
		buscaInsercion: {
			get () {
				return this.filtroStore.buscaInsercion
			},
			set (value) {
				this.setFiltro({buscaInsercion: value})
			}
		},
		filtroPost () {
			if (!this.filtro || !this.filtro.EmisoraID || !this.filtro.dia) {
				return {}
			}
			return {
				EmisoraID: this.filtro.EmisoraID,
				dia: Math.round(this.filtro.dia.getTime() / 1000),
				BloqueID: (this.bloqueActivo) ? this.bloqueActivo.BloqueID : null
			}
		}
	},
	methods: {
		...mapActions({
			getBloques: 'organizar-emisoras/getBloques',
			getParrilla: 'organizar-emisoras/getParrilla',
			getFavoritos: 'organizar-emisoras/getBuzonesFavoritos',
			setFiltro: 'organizar-emisoras/setFiltro',
			buscarInserciones: 'organizar-emisoras/buscarInserciones'
		}),
		...mapMutations({
			toggleOmitir: 'organizar-emisoras/TOGGLE_SIN_MATRICULA'
		}),
		calculaAlto () {
			let el = this.$refs.contenedor
			let offsetTop = this.$refs.contenedor.offsetTop
			while (el.parentElement) {
				el = el.parentElement
				offsetTop += el.offsetTop
			}
			const alto = window.innerHeight - offsetTop

			this.$refs.contenedor.style.height = alto + 'px'
		},
		cambiaDia (dia) {
			const diaActual = new Date(this.dia.getTime())
			diaActual.setDate(diaActual.getDate() + dia)
			this.dia = diaActual
		},
		getBuzones () {
			this.$http.get('organizar-emisoras/php/api/get-arbol-buzones.php')
				.then(res => {
					this.listadoBuzones = res.data.listado
				})
				.catch(this.$responseError)
		},
		seleccionaBuzon (e) {
			if (this.buzonActivo === e) return
			this.buzonActivo = e
		},
		_getEstilo (Color) {
			let hex = Color.toString(16)
			const reverse = (str) => {
				return (str === '') ? '' : reverse(str.substr(1)) + str.charAt(0)
			}
			hex = reverse(hex)

			// Calculamos si la cadena es de 6
			while (hex.length < 6) {
				hex = hex + '0'
			}

			hex = (hex === '000000') ? 'ffffff' : hex
			const getContrastYIQ = (r, g, b, opacidad) => {
				opacidad = 1 + opacidad
				const yiq = ((r * 299 * opacidad) + (g * 587 * opacidad) + (b * 114 * opacidad)) / 1000
				return (yiq >= 128) ? 'black' : 'white'
			}

			hex = hex.replace('#', '')
			const r = parseInt(hex.substring(0, 2), 16)
			const g = parseInt(hex.substring(2, 4), 16)
			const b = parseInt(hex.substring(4, 6), 16)
			const opacidad = 0.6

			hex = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacidad + ')'

			return {
				backgroundColor: hex,
				color: getContrastYIQ(r, g, b, opacidad)
			}
		},
		getListadoEmisoras () {
			this.$http.get('organizar-emisoras/php/api/get-emisoras.php')
				.then(res => {
					this.listadoEmisoras = res.data.listado
				})
				.catch(this.$responseError)
		}
	}
}
</script>

<style scoped>
	.contenedor {
		display: flex;
		flex-wrap: nowrap;
		flex-direction: row;
		flex-grow: 1;
		align-content: stretch;
		align-items: stretch;
		align-self: stretch;
		width: 100%;
		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari */
		-khtml-user-select: none; /* Konqueror HTML */
		-moz-user-select: none; /* Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
		user-select: none; /* Non-prefixed version, currently */
	}
	.contenedor > .colA {
		flex-grow: 2;
		flex-shrink: 0;
		flex-basis: 0;
		display: flex;
		flex-wrap: nowrap;
		flex-direction: column;
		align-content: stretch;
		align-items: stretch;
		align-self: stretch;
		padding: 0;
		margin-right:2px;
		padding: 2px;
	}

	.colA > .formulario {
		margin-bottom: 2px;
	}

	.colA > .favoritos {
		display: flex;
		flex-grow: 1;
		flex-shrink: 0;
		flex-basis: fill;
		align-content: stretch;
		align-items: stretch;
		align-self: stretch;
		margin-top: 2px;
	}
	.contenedor > .colB {
		flex-grow: 7;
		flex-shrink: 0;
		flex-basis: 0;
		display: flex;
		flex-wrap: nowrap;
		flex-direction: column;
		align-content: stretch;
		align-items: stretch;
		align-self: stretch;
		padding: 0;
		margin-right:2px;
	}

	.contenedor > .colC {
		flex-grow: 2;
		flex-shrink: 0;
		flex-basis: 0;
		display: flex;
		flex-wrap: nowrap;
		flex-direction: column;
		align-content: stretch;
		align-items: stretch;
		align-self: stretch;
		padding: 0;
		margin-left:2px;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.colB > .contieneTabla {
		flex-grow: 1;
		flex-shrink: 1;
		flex-basis: 0;
		overflow-y: auto;
		background-color: white;
		margin-bottom: 2px;
		border: 1px solid #e0e0e0;
	}

	.colB > .contieneBloque {
		flex-grow: 1;
		flex-shrink: 1;
		flex-basis: 0;
		overflow-y: auto;
		background-color: white;
		margin-top: 2px;
		border: 1px solid #e0e0e0;
	}

	.colC > .contieneBuzones {
		flex-grow: 1;
		flex-shrink: 1;
		flex-basis: 0;
		overflow-y: auto;
		margin-bottom: 2px;
		border: 1px solid #e0e0e0;
	}

	.colC > .contieneFicheros {
		display: flex;
		align-content: stretch;
		align-items: stretch;
		align-self: stretch;
		flex-direction: column;
		flex-grow: 1;
		flex-shrink: 1;
		flex-basis: 0;
		overflow-y: auto;
		background-color: white;
		margin-top: 2px;
		margin-right: 2px;
		margin-bottom: 2px;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/organizar-emisoras/vue/paginas/organizar/organizar.vue